export * from './move-to-plate-adapter';
